import { render, staticRenderFns } from "./GameOverResult.vue?vue&type=template&id=065ca808&scoped=true&"
import script from "./GameOverResult.vue?vue&type=script&lang=js&"
export * from "./GameOverResult.vue?vue&type=script&lang=js&"
import style0 from "./GameOverResult.vue?vue&type=style&index=0&id=065ca808&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ca808",
  null
  
)

export default component.exports